import '../styles/main.scss';
import 'intersection-observer';
import 'picturefill';
import footer from '../components/footer';
import navigation from '../components/navigation';
import navigationSub from '../components/navigation-sub';
import initCarousels from './modules/carousel/init';
import initForms from './modules/form/init';
import initVideos from './modules/Video/init';
import initGaTracking from './utils/gaTracking';
import initMotionComponents from './modules/MotionWrapper/init';
import initRegionSwitch from './modules/RegionSwitcher/init';
import initAccordion from './modules/Accordion/init';
import social from '../components/editorial';
import siteHeaderSearchBlock from '../components/site-header';
import searchForm from '../components/search-form';
import calibremindidentify from '../components/calibremind';
import quotesCarousel from '../components/quote-carousel';
import initCareers from '../components/careers';
import initArticleListing from '../components/article-listing-with-filters';

footer();
navigation();
navigationSub();
initMotionComponents();
initCarousels();
social();
siteHeaderSearchBlock();
searchForm();
quotesCarousel();
initCareers();
initArticleListing();
initRegionSwitch();
initAccordion();

window.addEventListener('load', () => {
	initVideos();
	initForms();
	initGaTracking();
	calibremindidentify();
});

if (module.hot) {
	module.hot.accept();
}
